//frontend/src/components/api/api.js

import { refreshAccessToken } from "./auth";

const IS_DEV_NO_AUTH = process.env.REACT_APP_DEV_NO_AUTH === "true";

export async function authFetch(url, options = {}) {
  let access = localStorage.getItem("access_token");

  // Если включен режим без авторизации, и токена нет - просто делаем запрос
  if (!access && !IS_DEV_NO_AUTH) {
    throw new Error("No access token");
  }

  const doFetch = (token) => {
    const headers = { ...options.headers };
    
    // Добавляем токен только если он есть
    if (token) {
      headers.Authorization = `JWT ${token}`;
    }

    return fetch(url, {
      ...options,
      headers,
    });
  };

  let res = await doFetch(access);

  // Если вернулась 401 и мы не в режиме no-auth, пробуем обновить токен
  if (res.status === 401 && !IS_DEV_NO_AUTH) {
    const refreshed = await refreshAccessToken();
    if (!refreshed) {
      localStorage.clear();
      window.location.reload();
      throw new Error("Session expired");
    }
    access = localStorage.getItem("access_token");
    res = await doFetch(access);
  }

  return res;
}